<template>
  <div class="container">
    <div class="row">
      <div class="col-lg-10 col-xl-9 mx-auto">
        <div class="card card-signin flex-row my-5">
          <div class="card-img-left d-none d-md-flex">
              <!-- Background image for card set in CSS! -->
          </div>
          <div class="card-body pt-5 pb-5">
            <h2>Sorry! We're currently experiencing difficulties.</h2>
            <p>Either we're in the middle of an upgrade or we're actively trying to fix the internet!  Give us another try in a few minutes.</p>
            <hr>
            <h4>First time here?</h4>
            <p>Welcome to My Event Cafe!  The Social Learning Platform for event driven activities.</p>
            <p>A social platform is the best way to engage your customers!  With event driven activities, social networking, daily reminders, and a fully customizable schedule, My Event Cafe is the only way to make learning fun!</p>
            <p>If you want more information, please contact <a href="mailto:support@myeventcafe.com">support@myeventcafe.com</a></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SiteDown'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.card-signin {
  border: 0;
  border-radius: 1rem;
  box-shadow: 0 0.5rem 1rem 0 rgba(167, 165, 165, 0.1);
  overflow: hidden;
}

.card-signin .card-title {
  margin-bottom: 2rem;
  font-weight: 300;
  font-size: 1.5rem;
}

.card-signin .card-img-left {
  min-width: 40%;
  /* Link to your background image using in the property below! */
  background: scroll center url('https://images.pexels.com/photos/2422265/pexels-photo-2422265.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940');
  background-size: cover;
}

.card-signin .card-body {
  padding: 2rem;
}
</style>
